export const 
    capital_factory = require('./capital-factory.svg'),
    firebrand = require('./firebrand_vc.svg'),
    live_oak = require('./live-oak.svg'),
    mark_vc = require('./mark-vc.svg'),
    next_coast_ventures = require('./next-coast.svg'),
    notley = require('./notley.svg');